import Vue from 'vue';
import VueRouter from 'vue-router';
import Meta from 'vue-meta';

const page = path => () => import(`@/views/pages${ path }.vue`);

Vue.use(VueRouter);
Vue.use(Meta);

const common_routes = [
  {
    path: '/',
    redirect: 'works',
  },
  {
    path: 'works',
    redirect: 'works/featured',
  },
  {
    path: 'works/:category',
    component: page('/works-list'),
  },
  {
    meta: { preview: true },
    path: 'works/preview/:slug',
    component: page('/works-article'),
  },
  {
    path: 'works/article/:slug',
    component: page('/works-article'),
  },
  {
    path: 'about',
    component: page('/about'),
  },
  {
    path: 'contact',
    component: page('/contact'),
  },
  {
    path: 'inquiry',
    component: page('/inquiry'),
    meta: { hideChrome: true },
  },
];

export default () => new VueRouter({
  mode: 'history',
  scrollBehavior: () => null,
  routes: [
    {
      path: `/`,
      component: page('/language-root'),
      children: [
        ...common_routes,
      ],
    },
    // {
    //   path: `/:locale(en)?`,
    //   component: page('/language-root'),
    //   children: [
    //     ...common_routes,
    //   ],
    // },
    {
      path: '/test',
      component: page('/parallax-test'),
    },
  ],
})
